import Box from "@mui/material/Box";
import React from "react";
import { useSelector } from "react-redux";

import { Login } from "@/components/Login";
import { TaskList } from "@/components/TaskList";
import { RootState } from "@/redux/store";

export const AuthLayout: React.FC = () => {
  const { jwtToken } = useSelector(
    (state: RootState) => state.authSlice,
  );

  return (
    <Box>
      { jwtToken ? <TaskList /> : <Login /> }
    </Box>
  );
};
